export default {
    fullSizeEditorMinWidth: 1274
};
